import { render, staticRenderFns } from "./CarrierForm.vue?vue&type=template&id=03b2d802&scoped=true&"
import script from "./CarrierForm.vue?vue&type=script&lang=ts&"
export * from "./CarrierForm.vue?vue&type=script&lang=ts&"
import style0 from "./CarrierForm.vue?vue&type=style&index=0&id=03b2d802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b2d802",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
